import { Link } from "react-router-dom";

export function Logo({ className = "", onClick }) {
  return (
    <Link to="/" onClick={onClick} data-testid="logo-link" className={`flex items-center gap-2.5 group ${className}`}>
      <img
        src="/logo.png"
        alt="Saad IPTV"
        className="h-10 w-10 rounded-lg object-cover shadow-[0_0_18px_rgba(59,130,246,0.45)]"
      />
      <span className="font-heading font-extrabold text-xl tracking-tight text-white">
        Saad<span className="bg-gradient-to-r from-amber-300 to-amber-500 bg-clip-text text-transparent">IPTV</span>
      </span>
    </Link>
  );
}
